<int-field-box
  [isError]="isError"
  [isFocus]="isFocus"
>
  <div class="wrap" [class]="direction">
    <div class="cols" [class]="vAlignValue">
      <div class="col-left">
        <ng-content select="left-position"></ng-content>
      </div>
      <div class="col-center"
         [class.hide-field]="hideField"
         [class.ii-focused]="isActive"
      >
        <ng-container *ngTemplateOutlet="isLabelBox ? labelBox : defaultBox"></ng-container>
      </div>
      <div class="col-right">
        <ng-content select="right-position"></ng-content>
      </div>
    </div>
  </div>
</int-field-box>

<ng-template #center>
  <ng-content select="center-position"></ng-content>
</ng-template>

<ng-template #labelBox>
  <label class="b-label">
    <span class="b-tip" [class.b-tip--is-error]="isError" *ngIf="showLabelTip">
      {{label}}
    </span>
    <div class="b-inner" (click)="onContentClick()">
      <ng-container *ngTemplateOutlet="center"></ng-container>
    </div>
  </label>
</ng-template>

<ng-template #defaultBox>
  <div class="b-label">
    <span class="b-tip" [class.b-tip--is-error]="isError" *ngIf="showLabelTip">
      {{label}}
    </span>
    <div class="b-inner" (click)="onContentClick()">
      <ng-container *ngTemplateOutlet="center"></ng-container>
    </div>
  </div>
</ng-template>
